// Translations for AZ / EN / RU — every user-facing string lives here.
// Rule: selecting a language must NEVER leak strings from another language.
export const translations = {
  az: {
    nav: { home: "Ana səhifə", catalog: "Kateqoriyalar", artists: "Sənətçilər", track: "Sifarişi izlə", admin: "Admin", giftCards: "Hədiyyə Kartı", myGiftCards: "Hədiyyə Kartlarım", wheel: "Şans Çarxı" },
    common: {
      cart: "Səbət", wishlist: "Seçilmişlər", login: "Giriş", register: "Qeydiyyat",
      logout: "Çıxış", search: "Axtar...", searchShort: "AXTAR", price: "QİYMƏT", buy: "Əlavə et",
      currency: "VALYUTA", language: "DİL",
      addToCart: "Səbətə at", checkout: "Ödənişə keç", free: "Pulsuz",
      total: "CƏMİ", subtotal: "ARA CƏM", delivery: "ÇATDIRILMA",
      empty: "Hələ heç nə yoxdur", continueShopping: "Alışa davam et",
      loading: "Yüklənir...", spinning: "İNDİ SƏSLƏNİR",
      profile: "Profil", account: "Hesab",
      newHere: "İlk dəfəsiniz?", alreadyMember: "Artıq hesabınız var?",
      status: "STATUS", item: "MƏHSUL", items: "MƏHSUL",
    },
    hero: {
      eyebrow: "PREMİUM SEÇİM — BAKI, AZ",
      title: "Analoq ruh, rəqəmsal dünyada.",
      desc: "Bakı audiofil cəmiyyəti üçün ən nadir vinil presləri. Nadir caz idxallarından müasir elektronik şedevrlərə qədər.",
      shopFeatured: "Seçilmişlərə bax", viewArchive: "Arxivə bax",
      scrollDown: "Aşağı sürüşdür",
      marquee: ["ANALOQ RUH", "BAKIDA PRESLƏNİB", "180G TƏMİZ VİNİL", "AUDİOFİL KEYFİYYƏT", "2019-DAN BƏRİ"],
    },
    sections: {
      newArrivals: "Yeni Gələnlər", newArrivalsSub: "TƏZƏ PRESLƏNMİŞ VƏ GÖNDƏRİLMƏYƏ HAZIR",
      seeAll: "Hamısına bax", curated: "Qurator Kolleksiyalar",
      relatedReleases: "Oxşar Buraxılışlar", news: "Son Xəbərlər",
      tracklist: "Trek Siyahısı",
      latestReleases: "Son Buraxılışlar", recentlyAdded: "TƏZƏ ƏLAVƏ EDİLMİŞ",
      bestSellers: "Ən Çox Satılanlar", bestSellersSub: "QURATORLAR TƏRƏFİNDƏN SEÇİLMİŞ",
      collection: "KOLLEKSİYA",
      featuredArtist: "Seçilmiş Sənətçi",
      exploreDiscography: "Diskoqrafiyanı kəşf et",
      viewCatalog: "Kataloqa bax",
      browseCategories: "Kateqoriyalara bax",
    },
    product: {
      catNo: "BARKOD", format: "FORMAT", rpm: "RPM", weight: "ÇƏKİ",
      releaseDate: "BURAXILIŞ TARİXİ", price: "QİYMƏT",
      limited: "LİMİTLİ", newArrival: "YENİ",
      secondHand: "İKİNCİ ƏL", condition: "VƏZİYYƏT",
      spotifyPreview: "SPOTIFY ÖNBAXIŞI",
      breadcrumbCatalog: "KATALOQ",
    },
    catalog: {
      archive: "ARXİV / 01", releases: "BURAXILIŞ", all: "HAMISI",
      categoriesFilter: "KATEQORİYALAR", artistsFilter: "SƏNƏTÇİLƏR",
    },
    artists: {
      roster: "HEYƏT / 2026", featuredBadge: "SEÇİLMİŞ",
      theArtist: "SƏNƏTÇİ", curatedVinyl: "QURATORLU VİNİL",
      discography: "DİSKOQRAFİYA", viewAllReleases: "BÜTÜN BURAXILIŞLARA BAX →",
      noReleases: "Hələ buraxılış yoxdur.",
    },
    checkout: {
      title: "SİFARİŞ VƏ ÖDƏNİŞ", subtitle: "Çatdırılma məlumatlarını təsdiqləyin və ödənişi tamamlayın.",
      progress: "SİFARİŞ STATUSU",
      placed: "Sifariş Verildi", preparing: "Hazırlanır",
      withCourier: "Kuryerdə", onTheWay: "Yoldadır", delivered: "Çatdırıldı",
      shippingMethod: "ÇATDIRILMA ÜSULU", payment: "TƏHLÜKƏSİZ ÖDƏNİŞ",
      cardholder: "KART SAHİBİ", cardNumber: "KART NÖMRƏSİ",
      expiry: "ETİBARLIDIR", cvv: "CVV",
      complete: "ÖDƏNİŞİ TAMAMLA",
      address: "ÜNVAN", city: "ŞƏHƏR", phone: "TELEFON", fullName: "AD VƏ SOYAD", notes: "QEYDLƏR",
      placeOrder: "SİFARİŞİ VER",
      trackingPending: "İZLƏMƏ NÖMRƏSİ GÖZLƏYİR",
      shippingDetails: "ÇATDIRILMA MƏLUMATLARI",
      orderSummary: "SİFARİŞİN XÜLASƏSİ",
      demoMode: "DEMO REJİM — REAL ÖDƏNİŞ YOXDUR",
      cartEmptyAlert: "Səbət boşdur.",
      fillAllAlert: "Bütün zəruri sahələri doldurun.",
      placeFailedAlert: "Sifariş verilmədi",
    },
    track: {
      title: "SİFARİŞ İZLƏ", placeholder: "İzləmə nömrəsi (məs. VAZ-2026-XXXXXX)",
      track: "İZLƏ", noOrder: "Sifariş tapılmadı.",
      tracking: "İZLƏMƏ", trackingNo: "İZLƏMƏ #", itemsLabel: "MƏHSULLAR",
    },
    profile: {
      myOrders: "SİFARİŞLƏRİM",
      myOrdersDesc: "Çatdırılmaları və tarixçəni izləyin",
      myGiftCardsDesc: "Alınmış və qəbul edilmiş kartlar, kodlar və balanslar",
      adminDesc: "Məhsul, məzmun və bucket idarəsi",
    },
    mega: {
      seeFullCatalog: "Tam kataloqa bax →", viewAll: "Hamısına bax →",
      category: "KATEQORİYA", noSub: "Alt kateqoriya yoxdur",
      featuredHeading: "Seçilmiş",
      browseAll: "Bütün kateqoriyalar",
    },
    footer: {
      shop: "MAĞAZA", support: "DƏSTƏK", visit: "ZİYARƏT", company: "ŞİRKƏT",
      shopLinks: { newArrivals: "Yeni Gələnlər", catalog: "Kataloq", artists: "Sənətçilər", preorders: "Öncədən Sifariş" },
      supportLinks: { track: "Sifariş İzlə", shipping: "Çatdırılma", returns: "Geri Qaytarma", faq: "FAQ" },
      companyLinks: { about: "Haqqımızda", blog: "Yeniliklər", privacy: "Məxfilik siyasəti" },
    },
    admin: {
      dashboard: "İDARƏ PANELİ", products: "MƏHSULLAR", artists: "SƏNƏTÇİLƏR",
      categories: "KATEQORİYALAR", orders: "SİFARİŞLƏR", delivery: "ÇATDIRILMA",
      liveCarts: "CANLI SƏBƏTLƏR",
      revenue: "GƏLİR", customers: "MÜŞTƏRİLƏR", topSelling: "ƏN ÇOX SATILAN",
      topViewed: "ƏN ÇOX BAXILAN", topSearched: "ƏN ÇOX AXTARILAN",
      add: "ƏLAVƏ ET", edit: "DÜZƏLİŞ", delete: "SİL", save: "YADDA SAXLA",
      cancel: "LƏĞV ET", close: "BAĞLA", upload: "YÜKLƏ", uploading: "Yüklənir…",
      image: "ŞƏKİL", imageOrUrl: "və ya URL daxil edin",
      title: "BAŞLIQ", slug: "SLUG", name: "AD", description: "AÇIQLAMA",
      price: "QİYMƏT", stock: "STOK", category: "KATEQORİYA", artist: "SƏNƏTÇİ",
      artistOptional: "SƏNƏTÇİ (istəyə bağlı)", parent: "ANA KATEQORİYA (alt üçün)",
      none: "— YOXDUR —", order: "SIRA",
      new: "YENİ", edit2: "DÜZƏLİŞ",
      product: "MƏHSUL", addProduct: "MƏHSUL ƏLAVƏ ET", addCategory: "KÖK ƏLAVƏ ET",
      addSub: "+ ALT", addArtist: "SƏNƏTÇİ ƏLAVƏ ET",
      noProducts: "HƏLƏ MƏHSUL YOXDUR", noCategories: "HƏLƏ KATEQORİYA YOXDUR",
      noArtists: "HƏLƏ SƏNƏTÇİ YOXDUR", noOrders: "HƏLƏ SİFARİŞ YOXDUR",
      noCustomers: "HƏLƏ MÜŞTƏRİ YOXDUR", noNotifications: "HƏLƏ BİLDİRİŞ YOXDUR",
      noCoupons: "HƏLƏ KUPON YOXDUR", noCarts: "HƏLƏ AKTİV SƏBƏT YOXDUR",
      deleteConfirm: "silinsin?",
      format: "FORMAT", rpm: "RPM", weight: "ÇƏKİ", catNo: "BARKOD",
      releaseDate: "BURAXILIŞ TARİXİ", coverImage: "ÜZ ŞƏKLİ",
      featured: "SEÇİLMİŞ", limited: "LİMİTLİ", newArrival: "YENİ GƏLƏN",
      bio: "BİO", spotifyTrackId: "SPOTIFY TRACK ID",
      spotifyHint: 'Spotify URL-dən götürülən ID — məsələn: "spotify.com/track/7xGfFoTpQ2E..." → 7xGfFoTpQ2E...',
      required: "tələb olunur.",
      controlCenter: "İDARƏ MƏRKƏZİ",
      siteContent: "SAYT MƏTNLƏRİ", siteContentDesc: "Hero, footer və sayt mətnləri",
      r2Buckets: "NAJAFLI SAİD", r2Desc: "Şəkil saxlama bucket-ləri",
      notifications: "BİLDİRİŞLƏR", coupons: "KUPONLAR", analytics: "ANALİTİKA",
      backToStore: "MAĞAZAYA QAYIT", logout: "ÇIXIŞ",
      saved: "Yadda saxlandı ✓",
      // analytics page
      totalCustomers: "ÜMUMİ MÜŞTƏRİ", totalOrders: "ÜMUMİ SİFARİŞ",
      totalRevenue: "ÜMUMİ GƏLİR", pendingOrders: "GÖZLƏMƏDƏ",
      topFavorited: "ƏN ÇOX SEVİLƏN", views: "BAXIŞ", favCount: "SEÇ.",
      // notifications
      notifTitle: "BAŞLIQ", notifBody: "MƏTN", notifTarget: "HƏDƏF",
      notifAll: "Hamı", notifUser: "Konkret müştəri", notifSend: "GÖNDƏR",
      notifType: "TİP", typeInfo: "Məlumat", typePromo: "Promosiya", typeWarn: "Xəbərdarlıq",
      // coupons
      couponCode: "KOD", couponPercent: "FAİZ (%)", couponAmount: "MƏBLƏĞ (AZN)",
      couponMaxUses: "MAX İSTİFADƏ (0 = limitsiz)", couponExpires: "BİTMƏ TARİXİ",
      couponUser: "MÜŞTƏRİ (opsional — boşdursa hamıya açıqdır)",
      couponActive: "AKTİV", couponUsed: "İSTİFADƏ",
      addCoupon: "KUPON ƏLAVƏ ET",
      // customers
      userEmail: "EMAIL", userName: "AD", userJoined: "QEYDİYYAT", userRole: "ROL",
      viewOrders: "SİFARİŞLƏRƏ BAX", viewCart: "SƏBƏTƏ BAX", issueCoupon: "KUPON VER",
      customerCart: "MÜŞTƏRİ SƏBƏTİ",
      // orders
      tracking: "İZLƏMƏ", customer: "MÜŞTƏRİ", total: "CƏM", date: "TARİX",
      setStatus: "STATUS DƏYİŞ",
      // live carts
      liveRefresh: "CANLI • 5s YENİLƏNMƏ", active: "AKTİV",
      anonymous: "Anonim Ziyarətçi",
    },
    notif: {
      title: "BİLDİRİŞLƏR", empty: "Bildiriş yoxdur",
      markAllRead: "HAMISINI OXUNMUŞ ET",
    },
    fav: {
      title: "SEÇİLMİŞLƏR", empty: "Seçilmişlər siyahısı boşdur",
      add: "Seçilmişlərə əlavə et", remove: "Seçilmişlərdən çıxar",
      loginPrompt: "Seçilmişlər üçün giriş edin",
    },
    coupon: {
      label: "KUPON KODU", apply: "TƏTBİQ ET", applied: "Tətbiq edildi ✓",
      invalid: "Kupon tapılmadı və ya etibarsızdır", remove: "Sil",
      discount: "ENDİRİM",
    },
  },

  en: {
    nav: { home: "Home", catalog: "Categories", artists: "Artists", track: "Track order", admin: "Admin", giftCards: "Gift Card", myGiftCards: "My Gift Cards", wheel: "Lucky Wheel" },
    common: {
      cart: "Cart", wishlist: "Wishlist", login: "Login", register: "Register",
      logout: "Logout", search: "Search...", searchShort: "SEARCH", price: "PRICE", buy: "Add",
      currency: "CURRENCY", language: "LANGUAGE",
      addToCart: "Add to cart", checkout: "Checkout", free: "Free",
      total: "TOTAL", subtotal: "SUBTOTAL", delivery: "DELIVERY",
      empty: "Nothing here yet", continueShopping: "Continue shopping",
      loading: "Loading...", spinning: "CURRENTLY SPINNING",
      profile: "Profile", account: "Account",
      newHere: "New here?", alreadyMember: "Already a member?",
      status: "STATUS", item: "ITEM", items: "ITEMS",
    },
    hero: {
      eyebrow: "PREMIUM SELECTION — BAKU, AZ",
      title: "Analog soul in a digital world.",
      desc: "Curating the finest vinyl pressings for the Baku audiophile community. From rare jazz imports to contemporary electronic masterpieces.",
      shopFeatured: "Shop featured", viewArchive: "View archive",
      scrollDown: "Scroll down",
      marquee: ["ANALOG SOUL", "PRESSED IN BAKU", "180G PURE VINYL", "AUDIOPHILE GRADE", "EST. 2019"],
    },
    sections: {
      newArrivals: "New Arrivals", newArrivalsSub: "FRESHLY PRESSED AND READY TO SHIP",
      seeAll: "See all", curated: "Curated Collections",
      relatedReleases: "Related Releases", news: "Latest News",
      tracklist: "Tracklist",
      latestReleases: "Latest Releases", recentlyAdded: "RECENTLY ADDED",
      bestSellers: "Best Sellers", bestSellersSub: "HAND-PICKED BY OUR CURATORS",
      collection: "COLLECTION",
      featuredArtist: "Featured Artist",
      exploreDiscography: "Explore discography",
      viewCatalog: "View catalog",
      browseCategories: "Browse categories",
    },
    product: {
      catNo: "BARCODE", format: "FORMAT", rpm: "RPM", weight: "WEIGHT",
      releaseDate: "RELEASE DATE", price: "PRICE",
      limited: "LIMITED", newArrival: "NEW ARRIVAL",
      secondHand: "SECOND-HAND", condition: "CONDITION",
      spotifyPreview: "SPOTIFY PREVIEW",
      breadcrumbCatalog: "CATALOG",
    },
    catalog: {
      archive: "ARCHIVE / 01", releases: "RELEASES", all: "ALL",
      categoriesFilter: "CATEGORIES", artistsFilter: "ARTISTS",
    },
    artists: {
      roster: "ROSTER / 2026", featuredBadge: "FEATURED",
      theArtist: "THE ARTIST", curatedVinyl: "CURATED VINYL",
      discography: "DISCOGRAPHY", viewAllReleases: "VIEW ALL RELEASES →",
      noReleases: "No releases yet.",
    },
    checkout: {
      title: "ORDER & CHECKOUT", subtitle: "Confirm your shipping details and complete payment to finalize your acquisition.",
      progress: "ORDER PROGRESS",
      placed: "Order Placed", preparing: "Preparing",
      withCourier: "With Courier", onTheWay: "On the Way", delivered: "Delivered",
      shippingMethod: "SHIPPING METHOD", payment: "SECURE PAYMENT",
      cardholder: "CARDHOLDER NAME", cardNumber: "CARD NUMBER",
      expiry: "EXPIRY DATE", cvv: "CVV",
      complete: "COMPLETE PURCHASE",
      address: "ADDRESS", city: "CITY", phone: "PHONE", fullName: "FULL NAME", notes: "NOTES",
      placeOrder: "PLACE ORDER",
      trackingPending: "TRACKING # PENDING",
      shippingDetails: "SHIPPING DETAILS",
      orderSummary: "ORDER SUMMARY",
      demoMode: "DEMO MODE — NO REAL CHARGE",
      cartEmptyAlert: "Cart is empty.",
      fillAllAlert: "Please fill all required fields.",
      placeFailedAlert: "Failed to place order",
    },
    track: {
      title: "TRACK ORDER", placeholder: "Tracking # (e.g. VAZ-2026-XXXXXX)",
      track: "TRACK", noOrder: "Order not found.",
      tracking: "TRACKING", trackingNo: "TRACKING #", itemsLabel: "ITEMS",
    },
    profile: {
      myOrders: "MY ORDERS",
      myOrdersDesc: "Track shipments and history",
      myGiftCardsDesc: "Purchased & received cards, codes and balances",
      adminDesc: "Manage products, content & buckets",
    },
    mega: {
      seeFullCatalog: "See full catalog →", viewAll: "View all →",
      category: "CATEGORY", noSub: "No sub-categories yet",
      featuredHeading: "Featured",
      browseAll: "Browse all categories",
    },
    footer: {
      shop: "SHOP", support: "SUPPORT", visit: "VISIT", company: "COMPANY",
      shopLinks: { newArrivals: "New Arrivals", catalog: "Catalog", artists: "Artists", preorders: "Pre-orders" },
      supportLinks: { track: "Track Order", shipping: "Shipping", returns: "Returns", faq: "FAQ" },
      companyLinks: { about: "About us", blog: "Journal", privacy: "Privacy policy" },
    },
    admin: {
      dashboard: "DASHBOARD", products: "PRODUCTS", artists: "ARTISTS",
      categories: "CATEGORIES", orders: "ORDERS", delivery: "DELIVERY",
      liveCarts: "LIVE CARTS",
      revenue: "REVENUE", customers: "CUSTOMERS", topSelling: "TOP SELLING",
      topViewed: "TOP VIEWED", topSearched: "TOP SEARCHED",
      add: "ADD", edit: "EDIT", delete: "DELETE", save: "SAVE",
    },
    notif: {
      title: "NOTIFICATIONS", empty: "No notifications",
      markAllRead: "MARK ALL READ",
    },
    fav: {
      title: "FAVORITES", empty: "Your favorites list is empty",
      add: "Add to favorites", remove: "Remove from favorites",
      loginPrompt: "Sign in to save favorites",
    },
    coupon: {
      label: "COUPON CODE", apply: "APPLY", applied: "Applied ✓",
      invalid: "Coupon is invalid or expired", remove: "Remove",
      discount: "DISCOUNT",
    },
  },

  ru: {
    nav: { home: "Главная", catalog: "Категории", artists: "Артисты", track: "Отследить", admin: "Админ", giftCards: "Подарочная карта", myGiftCards: "Мои подарочные карты", wheel: "Колесо Фортуны" },
    common: {
      cart: "Корзина", wishlist: "Избранное", login: "Вход", register: "Регистрация",
      logout: "Выйти", search: "Поиск...", searchShort: "ПОИСК", price: "ЦЕНА", buy: "В корзину",
      currency: "ВАЛЮТА", language: "ЯЗЫК",
      addToCart: "В корзину", checkout: "К оплате", free: "Бесплатно",
      total: "ИТОГО", subtotal: "ПОДЫТОГ", delivery: "ДОСТАВКА",
      empty: "Пока пусто", continueShopping: "Продолжить покупки",
      loading: "Загрузка...", spinning: "СЕЙЧАС ИГРАЕТ",
      profile: "Профиль", account: "Аккаунт",
      newHere: "Первый раз?", alreadyMember: "Уже есть аккаунт?",
      status: "СТАТУС", item: "ТОВАР", items: "ТОВАРЫ",
    },
    hero: {
      eyebrow: "ПРЕМИУМ ВЫБОР — БАКУ, AZ",
      title: "Аналоговая душа в цифровом мире.",
      desc: "Лучшие виниловые пластинки для аудиофилов Баку. От редкого джаза до современной электроники.",
      shopFeatured: "Избранное", viewArchive: "Архив",
      scrollDown: "Прокрутите вниз",
      marquee: ["АНАЛОГОВАЯ ДУША", "ПРЕСС В БАКУ", "180G ЧИСТЫЙ ВИНИЛ", "АУДИОФИЛЬСКОЕ КАЧЕСТВО", "С 2019"],
    },
    sections: {
      newArrivals: "Новинки", newArrivalsSub: "ТОЛЬКО ЧТО ОТПРЕССОВАНО",
      seeAll: "Смотреть все", curated: "Подборки",
      relatedReleases: "Похожие", news: "Новости",
      tracklist: "Треклист",
      latestReleases: "Последние Релизы", recentlyAdded: "НЕДАВНО ДОБАВЛЕНО",
      bestSellers: "Хиты Продаж", bestSellersSub: "ОТОБРАНЫ КУРАТОРАМИ",
      collection: "КОЛЛЕКЦИЯ",
      featuredArtist: "Артист месяца",
      exploreDiscography: "Дискография",
      viewCatalog: "Смотреть каталог",
      browseCategories: "Все категории",
    },
    product: {
      catNo: "ШТРИХ-КОД", format: "ФОРМАТ", rpm: "RPM", weight: "ВЕС",
      releaseDate: "ДАТА ВЫХОДА", price: "ЦЕНА",
      limited: "ЛИМИТ", newArrival: "НОВИНКА",
      secondHand: "Б/У", condition: "СОСТОЯНИЕ",
      spotifyPreview: "ПРЕВЬЮ SPOTIFY",
      breadcrumbCatalog: "КАТАЛОГ",
    },
    catalog: {
      archive: "АРХИВ / 01", releases: "РЕЛИЗОВ", all: "ВСЕ",
      categoriesFilter: "КАТЕГОРИИ", artistsFilter: "АРТИСТЫ",
    },
    artists: {
      roster: "СОСТАВ / 2026", featuredBadge: "ИЗБРАННЫЙ",
      theArtist: "АРТИСТ", curatedVinyl: "ВИНИЛ",
      discography: "ДИСКОГРАФИЯ", viewAllReleases: "ВСЕ РЕЛИЗЫ →",
      noReleases: "Релизов пока нет.",
    },
    checkout: {
      title: "ОФОРМЛЕНИЕ", subtitle: "Подтвердите доставку и завершите оплату.",
      progress: "СТАТУС ЗАКАЗА",
      placed: "Создан", preparing: "Готовится",
      withCourier: "У Курьера", onTheWay: "В Пути", delivered: "Доставлен",
      shippingMethod: "СПОСОБ ДОСТАВКИ", payment: "БЕЗОПАСНАЯ ОПЛАТА",
      cardholder: "ИМЯ НА КАРТЕ", cardNumber: "НОМЕР КАРТЫ",
      expiry: "СРОК", cvv: "CVV",
      complete: "ЗАВЕРШИТЬ ПОКУПКУ",
      address: "АДРЕС", city: "ГОРОД", phone: "ТЕЛЕФОН", fullName: "ИМЯ", notes: "ЗАМЕТКИ",
      placeOrder: "ОФОРМИТЬ ЗАКАЗ",
      trackingPending: "НОМЕР ОТСЛЕЖИВАНИЯ ГОТОВИТСЯ",
      shippingDetails: "ДАННЫЕ ДОСТАВКИ",
      orderSummary: "СВОДКА ЗАКАЗА",
      demoMode: "ДЕМО РЕЖИМ — ОПЛАТА НЕ ВЗИМАЕТСЯ",
      cartEmptyAlert: "Корзина пуста.",
      fillAllAlert: "Заполните все обязательные поля.",
      placeFailedAlert: "Не удалось оформить заказ",
    },
    track: {
      title: "ОТСЛЕДИТЬ ЗАКАЗ", placeholder: "№ отслеживания (напр. VAZ-2026-XXXXXX)",
      track: "ОТСЛЕДИТЬ", noOrder: "Заказ не найден.",
      tracking: "ОТСЛЕЖИВАНИЕ", trackingNo: "НОМЕР", itemsLabel: "ТОВАРЫ",
    },
    profile: {
      myOrders: "МОИ ЗАКАЗЫ",
      myOrdersDesc: "Отслеживайте доставку и историю",
      myGiftCardsDesc: "Купленные и полученные карты, коды и балансы",
      adminDesc: "Управление товарами, контентом и хранилищем",
    },
    mega: {
      seeFullCatalog: "Весь каталог →", viewAll: "Все →",
      category: "КАТЕГОРИЯ", noSub: "Подкатегорий пока нет",
      featuredHeading: "Избранное",
      browseAll: "Все категории",
    },
    footer: {
      shop: "МАГАЗИН", support: "ПОДДЕРЖКА", visit: "АДРЕС", company: "КОМПАНИЯ",
      shopLinks: { newArrivals: "Новинки", catalog: "Каталог", artists: "Артисты", preorders: "Предзаказ" },
      supportLinks: { track: "Отследить", shipping: "Доставка", returns: "Возврат", faq: "FAQ" },
      companyLinks: { about: "О нас", blog: "Журнал", privacy: "Политика конфиденциальности" },
    },
    admin: {
      dashboard: "ПАНЕЛЬ", products: "ТОВАРЫ", artists: "АРТИСТЫ",
      categories: "КАТЕГОРИИ", orders: "ЗАКАЗЫ", delivery: "ДОСТАВКА",
      liveCarts: "ЖИВЫЕ КОРЗИНЫ",
      revenue: "ВЫРУЧКА", customers: "КЛИЕНТЫ", topSelling: "ТОП ПРОДАЖ",
      topViewed: "ТОП ПРОСМОТРОВ", topSearched: "ТОП ПОИСКА",
      add: "ДОБАВИТЬ", edit: "ИЗМЕНИТЬ", delete: "УДАЛИТЬ", save: "СОХРАНИТЬ",
    },
    notif: {
      title: "УВЕДОМЛЕНИЯ", empty: "Уведомлений нет",
      markAllRead: "ОТМЕТИТЬ ВСЕ КАК ПРОЧИТАННЫЕ",
    },
    fav: {
      title: "ИЗБРАННОЕ", empty: "Список избранного пуст",
      add: "В избранное", remove: "Удалить из избранного",
      loginPrompt: "Войдите, чтобы сохранять избранное",
    },
    coupon: {
      label: "ПРОМО-КОД", apply: "ПРИМЕНИТЬ", applied: "Применено ✓",
      invalid: "Купон недействителен или истёк", remove: "Убрать",
      discount: "СКИДКА",
    },
  },
};

